import _ from 'lodash';
import { call, put, takeEvery, delay, select, takeLatest } from 'redux-saga/effects';
import { Uchain } from '../redux/api/agent';
import { sagaActions } from './sagaActions';
import { getCSCELogsListSuccess, getFeedbackListSuccess, getMetricsListSuccess, updateIsLoading, updateOperationObj, getCSCEAppConfigSuccess, getCSCEAppConfigFailure, updateAppConfigDetailsLoading, updateAppConfigListLoading,updateResponseObject } from '../redux/reducers/reducerSlices/CSCEReducer';
import { addSuccess as getLiveChatLogListSuccess, addFailure as getLiveChatLogListFail, resetData as resetLiveChatLogList } from '../redux/reducers/reducerSlices/GetLiveChatLogDetails';
import { showAlert } from '../App/Assests/Utility';
import { toast } from 'react-toastify';
/**
 * Function to initiate the CSCE loader
 * @param {*} data 
 */
function* initiateCSCELoaderSaga(data) {
    try {
        yield put(updateIsLoading(data.payload))
    } catch (error) {
        yield put(updateIsLoading(false))
    }
    finally { yield put(updateIsLoading(false)) }
}

/**
 * Function to get the CSCE feedback
 * @param {*} data 
 */
function* getMetricsListSaga(data) {
    try {
        let tempStatusObj = { ...data.operationObj };
        yield put(updateIsLoading(true));
        const response = yield call(Uchain.csceMetrics, data.payload)
        if (tempStatusObj.type === 'Fetch Metrics' && response) {
            tempStatusObj.status = true
            yield put(getMetricsListSuccess(response))
            yield put(updateOperationObj(tempStatusObj));
        }
    } catch (error) {
        yield put(updateIsLoading(false))
    }
    finally { yield put(updateIsLoading(false)) }
}

/**
 * Function to get the Live chat log details
 * @param {*} data 
 */
function* getLiveChatlogListSaga(data) {
    try {
        const response = yield call(Uchain.getCSLiveChatHistoryDetails, data.payload)
        yield put(getLiveChatLogListSuccess(response));
    } catch (error) {
        yield put(getLiveChatLogListFail(error))
    }
}

function* resetLiveChatlogListSaga() {
    yield put(resetLiveChatLogList());
}

function* clearMetricsListSaga() {
    try {
        yield put(getMetricsListSuccess([]))
    } catch (error) {
        yield put(getMetricsListSuccess([]))
    }
    finally { }
}

/**
 * Function to get the CSCE feedback
 * @param {*} data 
 */
function* getCSCELogsListSaga(data) {
    try {
        let tempStatusObj = { ...data.operationObj };
        yield put(updateIsLoading(true));
        const response = yield call(Uchain.csceLogs, data.payload)
        if (tempStatusObj.type === 'Fetch Logs' && response) {
            tempStatusObj.status = true
            yield put(getCSCELogsListSuccess(response))
            yield put(updateOperationObj(tempStatusObj));
        }
    } catch (error) {
        yield put(updateIsLoading(false))
    }
    finally { yield put(updateIsLoading(false)) }
}

function* clearCSCELogsListSaga() {
    try {
        yield put(getCSCELogsListSuccess([]))
    } catch (error) {
        yield put(getCSCELogsListSuccess([]))
    }
    finally { }
}

/**
 * Function for the CSCE Config Details
 * @param {*} data 
 */
function* csceAppConfigDetails(data) {
    try {
        yield put(updateResponseObject(null))

        if (data?.payload?.action && data?.payload?.action === 'read') {
            yield put(updateAppConfigListLoading(true))
        } else {
            yield put(updateAppConfigDetailsLoading(true));
        }

        const response = yield call(Uchain.cSCEAppConfigManagementDetails, data.payload)
        if (response) {
        if (data?.payload?.action.toLowerCase() === 'read' && response) {
            yield put(getCSCEAppConfigSuccess(response))
            // yield put(updateResponseObject(response))
        } else if (data?.payload?.action.toLowerCase() === 'create' && response) {
            showAlert(toast.TYPE.SUCCESS, response.message, 'light')
            yield put(updateResponseObject(response))
        } else if (data?.payload?.action.toLowerCase() === 'update' && response) {
            showAlert(toast.TYPE.SUCCESS, response.message, 'light')
            yield put(updateResponseObject(response))
        } else if (data?.payload?.action.toLowerCase() === 'delete' && response) {
            showAlert(toast.TYPE.SUCCESS, response.message, 'light')
            yield put(updateResponseObject(response))
        }
        }


    } catch (error) {
        showAlert(toast.TYPE.ERROR, error.message, 'light')
        // yield put(updateIsLoading(false))
    } finally {
        yield put(updateAppConfigListLoading(false))
        yield put(updateAppConfigDetailsLoading(false))
    }
}

function* clearCSCEConfigDetailsSaga() {
    try {
        yield put(getCSCEAppConfigSuccess([]))
        yield put(getCSCEAppConfigFailure([]))
        yield put(updateResponseObject(''))
    } catch (error) {
        yield put(getCSCEAppConfigSuccess([]))
        yield put(getCSCEAppConfigFailure([]))
        yield put(updateResponseObject(''))
    }
    finally { }
}

export function* initiateCSCELoaderWatcher() {
    yield takeLatest(sagaActions.INITIATE_CSCE_METRICS_LOADER, initiateCSCELoaderSaga)
}

export function* getMetricsListWatcher() {
    yield takeLatest(sagaActions.GET_CSCE_METRICS, getMetricsListSaga)
}

export function* clearMetricsListWatcher() {
    yield takeLatest(sagaActions.CLEAR_CSCE_METRICS, clearMetricsListSaga)
}

export function* getLiveChatLogDetailsWatcher() {
    yield takeLatest(sagaActions.CS_LIVE_CHAT_HISTORY_DETAILS, getLiveChatlogListSaga)
}

export function* resetLiveChatLogDetailsWatcher() {
    yield takeLatest(sagaActions.RESET_LIVE_CHAT_HISTORY_DETAILS, resetLiveChatlogListSaga)
}

export function* getCSCELogsListWatcher() {
    yield takeLatest(sagaActions.GET_CSCE_LOGS, getCSCELogsListSaga)
}

export function* cleaCSCELogsListWatcher() {
    yield takeLatest(sagaActions.CLEAR_CSCE_LOGS, clearCSCELogsListSaga)
}

export function* CSCEConfigDetailWatcher() {
    yield takeLatest(sagaActions.CSCE_CONFIG_DETAILS, csceAppConfigDetails)
}

export function* clearCSCEConfigDetailWatcher() {
    yield takeLatest(sagaActions.CLEAR_CSCE_CONFIG_DETAILS, clearCSCEConfigDetailsSaga)
}